<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
};
</script>

<style>
body {
    margin: 0;
    padding: 0;
    font-family: 'Arial' !important;
}
* {
    font-family: 'Arial' !important;
}

.ant-btn-sm {
    display: none;
}
.ant-popover-placement-top {
    left: 355.991px !important;
    top: 4966.99px;
    width: 12%;
}
.ant-popover-inner-content {
    padding: 0.0995rem 0.083333rem !important;
    color: rgba(0, 0, 0, 0.65);
}
.ant-message {
    top: 45% !important;
}
.anticon-close-circle svg,
.anticon-check-circle svg,
.anticon-info-circle svg,
.anticon-exclamation-circle svg {
    width: 1.7em !important;
    height: 1.7em !important;
}
.ant-message-notice-content {
    padding: 100px 0;
    width: 50%;
    font-size: 0.345833rem !important;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
}
.el-select-dropdown__item.selected {
    color: #585858;
    font-weight: 500;
}
/* ------------- mobile端样式(屏幕小于960px) ------------- */
@media only screen and (max-width: 960px) {
    .el-select-dropdown__item {
        font-size: 48px;
        line-height: 65px;
        height: 65px;
    }
    .anticon-close-circle svg,
    .anticon-check-circle svg,
    .anticon-info-circle svg,
    .anticon-exclamation-circle svg {
        width: 3em !important;
        height: 3em !important;
    }
    .el-select-dropdown__empty,
    .el-select-dropdown__item span {
        font-size: 48px;
    }
    .el-select-dropdown__wrap {
        min-height: 350px;
    }
    .ant-popover-inner-content {
        padding: 0.0995rem 0.083333rem !important;
        color: rgba(0, 0, 0, 0.65);
    }
    /* .ant-message-notice-content{
    padding: 100px 0 ;
    width: 50%;
    font-size:0.345833rem !important;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
} */
}
/* ------------- pc端样式(屏幕大于960px) ------------- */
@media only screen and (min-width: 960px) {
    .el-select-dropdown__item {
        font-size: 0.104167rem;
    }
    .el-select-dropdown__empty,
    .el-select-dropdown__item span {
        font-size: 0.104167rem;
    }
    .ant-popover-inner-content {
        padding: 0.0995rem 0.083333rem !important;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-message-notice-content {
        padding: 0.320833rem 0;
        width: 25%;
        font-size: 0.145833rem !important;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue